import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import Layout from "../../components/dashboard/Layout";
import LogoutMenu from "../../components/dashboard/Layout/logout-menu";
import StudentExamsTable from "../../containers/admin/student-exams/table";

const StudentExamsMain = () => {
    return (
        <Layout>
            <Flex alignItems='center' w='100%' justifyContent='space-between' m={4} p={4}>
                <Text fontSize='24px' fontWeight='600' color='main_1'>
                    اختبارات الطلاب الرئيسية
                </Text>
                <Box display={{ base: "none", md: "block" }}>
                    <LogoutMenu />
                </Box>

            </Flex>
            <Box w="100%" p={4}>
                <StudentExamsTable />
            </Box>
        </Layout>
    );
};
export default StudentExamsMain;
